import { useAchievementTypes, useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { AchievementIcon } from 'components/achievements';
import {
  DisplayFormattedDate,
  EmptyIndicator,
  FlexContainer,
  LinkButton,
  MoreOptions,
  TitleWithIcon,
  User
} from 'components/common';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import { DropdownButton } from 'components/common/dropdown';

import type { GetAchievementDiscussionAnalysesRes } from 'shared-types/responses';

const AchievementConversationAnalyses = () => {
  const { messages, user } = useReduxState();

  const achievementTypes = useAchievementTypes();

  const { data, loading } = useApiData<GetAchievementDiscussionAnalysesRes>({
    url: '/admin/achievements/discussion-analysis',
    onlyIf: Boolean(user?.id)
  });

  return (
    <div className="conversations">
      <Box
        headerContent={
          <LinkButton
            category="success"
            href="/achievements/conversation-analyses-new"
            icon="plus"
            size="header"
            text={messages.achievementConversationAnalysesNew}
          />
        }
        loading={loading}
        padding={0}
        title={messages.achievementConversationAnalyses}
      >
        {!data?.analyses?.length ? (
          <EmptyIndicator
            icon="comments"
            title={messages.achievementConversationAnalysesNoPrevious}
          />
        ) : (
          <BoxTable>
            <BoxTableHeader>
              <BoxTableCell>{messages.commonTitle}</BoxTableCell>
              <BoxTableCell>{messages.commonCreatedBy}</BoxTableCell>
              <BoxTableCell>{messages.excelDate}</BoxTableCell>
              <BoxTableCell></BoxTableCell>
            </BoxTableHeader>

            {data?.analyses.map((item, itemIndex) => (
              <BoxTableRow key={itemIndex}>
                <BoxTableCell>
                  <FlexContainer style={{ gap: 15, minWidth: 250 }}>
                    <AchievementIcon
                      size="small"
                      type={item.achievement?.type}
                    />

                    <TitleWithIcon
                      title={item.achievement?.title}
                      titleLink={{
                        href: `/achievements/conversation-analyses/${item.id}`
                      }}
                    >
                      {achievementTypes[item.achievement?.type]?.title}
                    </TitleWithIcon>
                  </FlexContainer>
                </BoxTableCell>

                <BoxTableCell>
                  <User user={item.user} />
                </BoxTableCell>

                <BoxTableCell>
                  <DisplayFormattedDate date={item.createdAt} />
                </BoxTableCell>

                <BoxTableCell shrink={true}>
                  <MoreOptions styleContentButtons={false}>
                    <DropdownButton
                      icon="file-pdf"
                      text={messages.commonDownloadPdf}
                    />
                  </MoreOptions>
                </BoxTableCell>
              </BoxTableRow>
            ))}
          </BoxTable>
        )}
      </Box>
    </div>
  );
};

export default AchievementConversationAnalyses;
